/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { ProductCarouselWithHeader } from '@teko/teko-ecommerce';
import {
  BaseProps,
  CommonStyles,
  styled,
  themeColor,
  Container,
} from '@teko/ds-desktop';
import { t } from 'i18n';
import { isServerless } from 'helpers';
import { useSearch } from 'hooks';
import { RECENTLY_VIEWED_PRODUCTS_KEY } from '../../../constants';
import { parseJsonStringSafely } from '@teko/utils';

export const RecentViewedProducts: React.FC = ({ ...props }) => {
  const recentViewedProductsSkus = isServerless()
    ? parseJsonStringSafely(
        localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY) || '[]',
        [],
      )
    : [];

  if (!recentViewedProductsSkus?.length) {
    return null;
  }
  const { result, isLoading } = useSearch(
    recentViewedProductsSkus.length
      ? {
          filter: {
            skus: recentViewedProductsSkus,
          },
          pageSize: 50,
          page: 1,
        }
      : {},
  );
  const products = result?.products || [];

  if (!products.length && !isLoading) return null;

  return (
    <Container {...props}>
      <Wrapper>
        <ProductCarouselWithHeader
          header={{ title: t('Sản phẩm vừa xem') }}
          products={products}
          regionName="viewedItem"
        />
      </Wrapper>
    </Container>
  );
};

const Wrapper = styled.div<BaseProps>(
  CommonStyles,
  `
    background: white;
    border-radius: 0.5rem;
    margin-bottom: 1.5rem;
    .product-card{
      border: 1px solid ${themeColor.divider};
      border-radius: 4px;
    }
  `,
);
